import classNames from 'classnames';
import PropTypes from 'prop-types';

import SvgColorImg from '../SvgColorImg';

const percentMargin = 20;

function SvgRatioColoredSvg(props) {
  const {
    description = '',
    src,
    className = 'h-8 w-8',
    baseClassname = 'fill-pxUiAlert',
    overlayPercent = 0,
    overlayClassname = 'fill-pxUiOk',
    showEdgePercent = 0,
    edgeClassname = 'fill-white',
  } = props;

  const adjustedPercent = percentMargin / 2 + ((100 - percentMargin) * overlayPercent / 100);

  return (
    <div className="relative shrink-0">
      <SvgColorImg
        className={classNames(edgeClassname, className)}
        description={description}
        src={src}
        imgColorAsCssFill
      />

      {/* Top of the image, background olor */}
      {(overlayPercent !== 100)
        ? (
            <div
              className="absolute w-full left-0 top-0 overflow-hidden"
              style={{
                height: `${(100 - adjustedPercent) - (showEdgePercent / 2)}%`,
              }}
            >
              <SvgColorImg
                className={classNames(
                  'absolute left-0 top-0',
                  className,
                  baseClassname,
                )}
                description={description}
                src={src}
                imgColorAsCssFill
                absolute
              />
            </div>
          )
        : null}

      {/* Bottom of the image, overlay color */}
      <div
        className="absolute w-full left-0 bottom-0 overflow-hidden"
        style={{
          height: `${(overlayPercent === 100)
            ? 100
            : adjustedPercent - (showEdgePercent / 2)}%`,
        }}
      >
        <SvgColorImg
          className={classNames(
            'absolute left-0 bottom-0',
            className,
            overlayClassname,
          )}
          description={description}
          src={src}
          imgColorAsCssFill
          absolute
        />
      </div>
    </div>
  );
}

SvgRatioColoredSvg.propTypes = {
  description: PropTypes.string,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  baseClassname: PropTypes.string,
  overlayPercent: PropTypes.number,
  overlayClassname: PropTypes.string,
  showEdgePercent: PropTypes.number,
  edgeClassname: PropTypes.string,
};

export default SvgRatioColoredSvg;
